export default {
  email: '电子邮件',
  physicalAddress: '物理地址',
  webSiteUrl: '网站网址',
  loadingApplication: '加载应用程序',
  baseUrl: '基本 URL',
  redirectionUrl: '重定向 URL',
  prefix: '前缀',
  pickAApplicationColor: '为您的应用程序选择颜色',
  applicationSuccessfullyUpdated: '已成功更新应用程序',
  apiKeyCopied: '复制的 Api 密钥',
  apiKeyCopyError: '复制 API 密钥错误',
  changingPublicKeyWillAffectApps: '更改公钥将影响正在使用的所有应用程序。是否要继续？',
  apiKey: 'API 密钥',
  goToApiDoc: '转到 API 文档',
  publicKey: '公钥',
  privateKey: '私钥',
  generate: '生成',
  reNewPublicKey: '续订公钥',
  deleteInfoField: '删除信息字段',
  sureToDeleteInfoField: '是否确实要删除此信息字段？',
  addInfoOfPeopleOfBrand: '有关品牌人员的其他信息',
  sectionAddInfoPeopleOfBrandRequested: '在本节中，您可以添加将从品牌人员处请求的其他信息',
  onlyBeSeenByAppAdministrator: '只能由应用程序管理员看到',
  canBeSeenByPeople: '可以看到和修改的人从他们的个人资料',
  shortTextField: '短文本字段',
  dropDownList: '下拉列表',
  addNewInfoField: '添加新信息字段',
  enterExtraDataId: '输入外数据标识符',
  epayCoCredentials: '埃帕伊科证书',
  emailVerifyCredentials: '电子邮件验证凭证',
  testEnvironment: '测试环境',
  update: '更新',
  modifyAddInfoField: '修改其他信息字段',
  createAddInfoField: '创建其他信息字段',
  fieldSuccessfullyDeleted: '已成功删除该字段',
  fieldName: '字段名称',
  access: '访问',
  addOptions: '添加选项',
  option: '选项 |选项',
  fieldSuccessfullyCreated: '已成功创建字段',
  fieldSuccessfullyUpdated: '已成功更新字段',
  application: '应用程序 |应用',
  addAdministrator: '添加管理员',
  administratorsPerPage: '每页的管理员',
  yes: '是的',
  no: '没有',
  loadingAdministrators: '正在加载管理员',
  noAdministratorsRegistered: '无注册管理员',
  action: '行动 |行动',
  publicKeyUpdated: '公钥已更新',
  editAdministrator: '编辑管理员',
  newAdministrator: '新管理员',
  selectAdministratorType: '选择管理员类型',
  wantAdministratorInactive: '是否要管理员处于非活动状态？',
  selectAdministratorPermissions: '选择管理员权限',
  addNewAdministrator: '添加新管理员',
  administratorSuccessfullyCreated: '已成功创建管理员',
  administratorSuccessfullyUpdate: '管理员已成功更新',
  wantToDeleteAdministrator: '是否要删除此管理员？',
  deleteAdministrator: '删除管理员',
  administratorSuccessfullyDeleted: '已成功删除管理员',
  successfullyColorUpdated: '颜色已成功更新',
  creditCard: '信用卡',
  inviteFinancier: '邀请金融家 |邀请金融家',
  billing: '计费',
  addCreditCard: '添加信用卡',
  loadBalance: '负载平衡',
  usage: '使用情况 |使用情况 |用法',
  payment: '付款 |付款 |付款 |付款',
  paymentMethods: '付款方法',
  completeBusinessDataBeforeAddingCreditCard: '在添加信用卡之前填写您的业务详细信息',
  lastDigits: '最后一位数字',
  cardExpirationDate: '有效期',
  changeToPrincipal: '更改为委托人',
  creditCardSuccessfullyDeleted: '已成功删除信用卡',
  errorDeletingCreditCard: '删除卡时出错',
  creditCardPriorityUpdated: '信用卡优先级更新',
  dailyUsage: '日常使用',
  report: '报告',
  recordsPerPage: '每页记录',
  loadingRecords: '加载记录',
  noMovementsRecords: '没有移动记录',
  service: '服务',
  amount: '量',
  value: '价值',
  successfullyMovementsReportDownloaded: '已成功下载移动报告',
  detailedConsumption: '详细消耗',
  approved: '已批准 |批准',
  creditCardRechargeWithOutCharge: '充值信用卡，免费',
  methodOf: '方法',
  billCollection: '账单收集',
  NoAdditionalInfoOfPayment: '没有额外的付款信息',
  noPaymentsRecords: '无付款记录',
  invoice: '发票',
  deposit: '存款',
  makePayment: '付款',
  warning: '警告',
  rechargeToAvoidBlockingMainFunctions: '您应该为帐户充值，以避免阻塞您的主要功能',
  load: '负荷',
  enterIdCardNumber: '输入您的身份证号码',
  idCardNumber: 'ID 号',
  createCard: '创建卡片',
  youMustCompleteCardInformation: '您必须填写您的信用卡详细信息',
  cardInformationIncorrect: '卡详细信息不正确',
  creditCardSuccessfullyAdded: '已成功添加信用卡',
  checkCardDetails: '检查卡详细信息',
  rejectedCard: '卡被拒绝',
  errorAddingCardPleaseTryAgain: '添加卡错误。请重试',
  /* Journeys */
  noDependencies: '无依赖项',
  dependsOn: '取决于',
  loadingJourneys: '装载旅程',
  noJourneysForThisApp: '此应用程序无行程',
  editJourney: '编辑旅程',
  addNewJourney: '添加新旅程',
  dependencies: '依赖',
  selectJourneyColor: '选择行程颜色',
  chooseAColor: '选择颜色',
  wantThisDefaultStateWhenSomeoneSignsUp: '是否要在某人注册时成为默认状态？',
  wantToShowThisStateOnTheSideMenu: '是否要在侧菜单中显示此状态？',
  loadingJourney: '装载旅程',
  addJourney: '添加旅程',
  journeySuccessfullyCreated: '成功创建旅程',
  journeySuccessfullyEdited: '成功编辑旅程',
  yellow: '黄色',
  orange: '橙',
  red: '红',
  purple: '紫色',
  darkBlue: '深蓝色',
  lightBlue: '浅蓝色',
  green: '绿色',
  wantToDeleteJourney: '是否要删除此旅程？',
  deleteJourney: '删除行程',
  journeySuccessfullyDeleted: '已成功删除行程',
  clickToSearchOnTheComputer: '...或单击此处搜索计算机上的文件',
  lastName: '姓氏',
  logInWith: '登录',
  signInWith: '使用',
  logInToYourAccount: '登录您的帐户',
  signIn: '登录',
  selectColor: '选择颜色',
  selectLogo: '选择徽标',
  customPhrase: '自定义短语',
  customPhraseOnLogIn: '登录时自定义短语',
  customPhraseOnSignIn: '登录时自定义短语',
  enterSignInMode: '输入登录模式',
  customPhraseOnLogInButton: '登录按钮上的自定义短语',
  customPhraseOnSignInButton: '登录按钮上的自定义短语',
  hideSocialNetworks: '隐藏社交网络',
  showSignInFirst: '先显示登录',
  showCustomButton: '显示自定义按钮',
  buttonText: '按钮文本',
  requestData: '请求数据',
  defaultData: '默认数据',
  identification: '识别',
  department: '部门',
  healthProvider: '健康提供者',
  bloodType: '血型',
  day: '日 |天',
  month: '月 |月',
  allTheData: '所有数据',
  year: '年份 |年',
  range: '范围',
  insertTheHtmlTemplateInTheFollowingField: '在以下字段中插入 html 模板',
  templatePreview: '模板预览',
  solo: '独奏',
  normal: '正常',
  needToRefreshBeforeCreateForms: '在创建窗体之前需要刷新',
  createForm: '创建窗体',
  formsPerPage: '每页窗体',
  loadingForms: '加载表单',
  noFormsRegistered: '没有注册的表单',
  formName: '窗体名称',
  insertFormOnWebSite: '在您的网站上插入表单',
  personalization: '个性化',
  injectableCode: '可注射代码',
  customYourFormAndInsertGeneratedCodeOnTheNextTab: '自定义表单，然后在以下选项卡上插入生成的代码',
  style: '风格',
  responseMessageSent: '已发送响应消息',
  sendButton: '发送按钮',
  length: '长度',
  alignment: '对准',
  selectFormColor: '选择窗体颜色',
  divWithKeybeFormsToInsertForm: '要将表单插入到网页，必须在网站正文中创建具有 ID',
  andThenAddTheNextScriptToTheFooter: '然后在网站页脚中添加以下脚本',
  left: '离开',
  right: '对',
  center: '中心',
  small: '小',
  large: '大',
  none: '没有',
  outlined: '概述',
  filled: '填充',
  editForm: '编辑表单',
  registerForm: '注册表格',
  obligateLogIn: '强制登录？',
  assignRoleWhenFormIsCompleted: '在表单填写时分配角色？',
  setUpNotificationsEmailForm: '设置电子邮件，在邮件中您将收到表单提交的通知',
  emailSubject: '电子邮件主题',
  sendEmailOnSubmit: '接收提交时发送电子邮件',
  sendSmsOnSubmit: '接收提交时发送短信',
  fields: '领域',
  addField: '添加字段',
  needToSelectRegisterEmailOrPhone: '您必须选择注册电子邮件或电话',
  formSuccessfullyEdited: '已成功编辑表单',
  fieldLength: '字段长度',
  required: '必填',
  minFiles: '最少文件数',
  linkOfTermsAndConditions: '链接到条款和条件',
  dataHandlingLink: '数据处理链接',
  verificationFields: '验证字段',
  filesUpLoad: '文件上传',
  dataManagement: '数据管理',
  hide: '隐藏',
  multipleOption: '多种选择',
  NoRestrictions: '无限制',
  fullRow: '完整行',
  halfRow: '半行',
  newForm: '新窗体',
  addNewForm: '添加新窗体',
  formSuccessfullyCreated: '窗体正确创建',
  files: '文件',
  fileType: '文件类型',
  responses: '反应',
  responsesPerPage: '每页响应',
  loadingResponses: '加载响应',
  noResponsesYet: '您尚未收到回复',
  next: '下一个',
  largeTextField: '大文本字段',
  registry: '注册 表',
  creatingANewApplicationIsVerySimpleJustFillInTheInformationWeRequestToGoToTheNextStep: '创建新应用程序非常简单，只需填写我们请求进入下一步的信息（设置社交网络）',
  applicationName: '应用程序名称',
  addNewApplication: '创建新应用程序',
  applicationSuccessfullyCreated: '已成功创建应用程序',
  saveNewBusiness: '保存新业务',
  thePageYouAreLookingForDoesNotExist: '您要查找的页面不存在',
  address: '地址',
  city: '市',
  country: '國家',
  cellPhone: '手機號碼',
  documentType: '證件類型',
  darkTheme: '黑暗主題',
  lightTheme: '淺色主題',
  sidebar: '側邊欄',
  toolbar: '工具列',
  money: '錢',
  showFieldInPeopleFilters: '在使用者的篩選器中顯示欄位',
  timeZoneInformation: `
  分配時區至關重要，這樣才能正確顯示分配給您的任務以及創建和更新數據的日期。
  `,
  profilePicUpdated: '个人资料图片已更新'
}
